t = require('app/scripts/views/internal/teacup-with-helpers')('popover_board_header_org_menu')

module.exports = t.renderable ({ canChangeOrg, setOrgNull, name, products, isOrgMember, upsellEnabled }) ->
  t.ul '.pop-over-list', ->
    if canChangeOrg
      t.li ->
        t.a '.js-change-org', { href: '#' }, ->
          if setOrgNull
            t.format 'remove-from-organization'
          if !setOrgNull
            t.format 'change-organization-ellipsis'
    t.li ->
      t.a '.js-view-org', { href: '/' + name }, ->
        t.format 'view-organization-page'
    if !products.length && isOrgMember && upsellEnabled
      t.li '.divide', ->
        t.a '.js-upgrade-to-bc', { href: '/' + name + '/billing' }, ->
          t.format 'upgrade-to-business-class'
